import { AxiosInstance, AxiosError } from 'axios';
import { Store } from 'vuex';
import { RootState } from '@/store/types';

export function addSmartMeterResponseInterceptors(axios: AxiosInstance, store: Store<RootState>): number {
  const smartMeterInterceptor = axios.interceptors.response.use((response) => response, (error: AxiosError) => {
    const response = error.response !== undefined ? error.response : error
    if (!response.config?.url?.startsWith('api/WorksRequest/get-work-file') &&
      !response.config?.url?.startsWith('api/consumptionMeasurements/connection-contract') &&
      !response.config?.url?.startsWith('api/worksrequest/smart-meter-request') &&
      !response.config?.url?.endsWith('/appointment/availabilities') &&
      !response.config?.url?.startsWith('api/stakeholder/work-requester')
      ) {
      store.dispatch('apiErrors/manageSmartMeter', response)
      return Promise.reject(error)
    } else {
      return response
    }
  })

  return smartMeterInterceptor
}
